//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import vueCropper from "vue-cropper";
// let vueCropper = require('../../node_modules/vue-cropper').default

export default {
  components: {
    
  },
  props: {},
  data() {
    return {
      cropperShow: false,
      name: this.local.nickname,
      example3: {
        img: "",
        autoCrop: true,
        autoCropWidth: 300,
        autoCropHeight: 300,
        fixedBox: true,
        canMoveBox: false

        // centerBox: true
      },
      base64: "",
      ncName: "",
      cnShow: false
    };
  },
  watch: {
    //观察Vue实例上的数据变动
  },
  computed: {
    //DOM加载后马上执行能够缓存数据
  },
  methods: {
    //触发事件
    posters() {
      if (this.ncName == "") {
        this.cnShow = true;
        this.$vux.toast.show({
          text: "请填写昵称",
          time: "2000",
          width: "2.5rem",
          position: "middle",
          type: "text"
        });
      } else {
        if (this.$refs.pathClear.value) {
          this.$vux.loading.show({
            text: "上传中..."
          });
          this.$router.push({
            name: "posters",
            query: {
              ncName: this.ncName
            }
            // ,query:{state:1}
          });
        } else {
          this.$vux.toast.show({
            text: "请上传图片",
            time: "2000",
            width: "2.5rem",
            position: "middle",
            type: "warn"
          });
        }
      }
    },
    again() {
      this.base64 = "";
      this.$refs.pathClear.dispatchEvent(new MouseEvent("click"));
    },
    cancel() {
      this.cropperShow = false;
      // this.$refs.pathClear.value = "";
    },
    fileImage: function(e) {
      var that = this;
      var file = e.target.files[0];
      var imgSize = file.size / 1024;
      if (imgSize > 5 * 1024) {
        alert("请上传大小不要超过5M的图片");
      } else {
        var reader = new FileReader();
        reader.readAsDataURL(file); // 读出 base64
        reader.onloadend = () => {
          // 图片的 base64 格式, 可以直接当成 img 的 src 属性值
          var dataURL = reader.result;
          this.cropperShow = true;
          this.example3.img = dataURL;
          // console.log(dataURL);
        };
      }
    },
    changeImg() {
      this.option.img = this.lists[~~(Math.random() * this.lists.length)].img;
    },
    startCrop() {
      // start
      this.crap = true;
      this.$refs.cropper.startCrop();
    },
    stopCrop() {
      //  stop
      this.crap = false;
      this.$refs.cropper.stopCrop();
    },
    clearCrop() {
      // clear
      this.$refs.cropper.clearCrop();
    },
    qdnc() {
      this.cnShow = false;
      if (this.ncName == "") {
        this.cnShow = true;
        this.$vux.toast.show({
          text: "请填写昵称",
          time: "2000",
          width: "2.5rem",
          position: "middle",
          type: "text"
        });
      } else {
        if (this.$refs.pathClear.value) {
          this.$vux.loading.show({
            text: "上传中..."
          });
          this.$router.push({
            name: "posters",
            query: {
              ncName: this.ncName
            }
            // ,query:{state:1}
          });
        } else {
          this.$vux.toast.show({
            text: "请上传图片",
            time: "2000",
            width: "2.5rem",
            position: "middle",
            type: "warn"
          });
        }
      }
    },
    // 实时预览函数
    realTime(data) {
      this.previews = data;
    },
    finish(type) {
      console.log(type);
      this.$refs.cropper.getCropData(data => {
        this.base64 = data;
        this.cropperShow = false;
        this.Global.userImg = data;
      });
    },

    down(type) {
      // event.preventDefault()
      // 输出
      if (type === "blob") {
        this.$refs.cropper.getCropBlob(data => {
          this.downImg = window.URL.createObjectURL(data);
          if (window.navigator.msSaveBlob) {
            var blobObject = new Blob([data]);
            window.navigator.msSaveBlob(blobObject, "demo.png");
          } else {
            this.$nextTick(() => {
              this.$refs.downloadDom.click();
            });
          }
        });
      } else {
        this.$refs.cropper.getCropData(data => {
          this.downImg = data;
          if (window.navigator.msSaveBlob) {
            var blobObject = new Blob([data]);
            window.navigator.msSaveBlob(blobObject, "demo.png");
          } else {
            this.$nextTick(() => {
              this.$refs.downloadDom.click();
            });
          }
        });
      }
    },

    uploadImg(e, num) {
      //上传图片
      // this.option.img
      var file = e.target.files[0];
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
        return false;
      }
      var reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        if (num === 1) {
          this.option.img = data;
        } else if (num === 2) {
          this.example2.img = data;
        }
      };
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file);
    }
  },
  created() {
    //页面渲染前调用
  },
  mounted() {
    //页面渲染完成调用
    var text = [
      `${this.local.nickname}本年度拍过的最烂照片，真是惊呆了！`,
      "魅族Note8 国民拍照手机，10月25日拯救你的烂照片。",
      `${this.local.nickname}晒了他半年度拍过的最烂照片，大家快来强势围观！`,
      `论拍烂照片，${
        this.local.nickname
      }至今还没怕过谁，不信？那你点进来比比。`,
      "照片拍不好，是你没有用魅族 Note8 国民拍照手机。"
    ];
    var _desc = Math.floor(Math.random() * text.length);
    // 微信分享
    console.log("微信分享");
    var appid = this.Global.appid;
    var wechat = new Wechat(appid);

    this.$vux.loading.hide();
    wechat.config({
      debug: false,
      jsApiList: [
        "checkJsApi",
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "onMenuShareQQ",
        "onMenuShareWeibo"
      ]
    });
    let _name = encodeURIComponent(this.local.nickname);
    // console.log("缓存" + _name);
    var share_url =
      location.href.split("#")[0] +
      "#" +
      this.$route.path +
      "?state=1&id=" +
      this.$route.query.id;

    console.log("参数解析");

    console.log(
      location.href.split("#")[0] + "#" + location.href.split("#")[1]
    );
    console.log("参数解析" + share_url);

    var title = "10.25 国民拍照手机魅族 Note8 新品发布会";
    var desc = text[_desc];
    wechat.shareFriend(
      {
        appmessageTitle: title,
        appmessageDesc: desc,
        link: share_url,
        imgUrl: "https://customer-cdn.tuzhanai.com/xfxb/static/J2qmSlfQ.jpg"
      },
      () => {
        // fiboSDK.share("friend");
        console.log("分享成功");
        let data = {
          openid: this.local.openid
        };
        this.save(data);
      },
      function() {
        console.log("cancel");
      }
    );

    wechat.shareTimeline(
      {
        timelineTitle: desc,
        link: share_url,
        imgUrl: "https://customer-cdn.tuzhanai.com/xfxb/static/J2qmSlfQ.jpg"
      },
      () => {
        let data = {
          openid: this.local.openid
        };
        this.save(data);
      },
      function() {}
    );
  }
};



// WEBPACK FOOTER //
// ./src/pages/upload.vue